import { FC } from 'react';

import ErrorMessage from '@/components/ui/ErrorMessage';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { clearCompanyInvoice } from '../helpers/companyInvoice';
import type { EcommerceFormValues } from '../schema';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const IS_COMPANY_NAME = 'is_company';

interface Props {
  name?: typeof IS_COMPANY_NAME;
}

const RadioGroupBuyerType: FC<Props> = ({ name = IS_COMPANY_NAME }) => {
  const { i18n } = useLingui();
  const form = useFormContext<EcommerceFormValues>();
  const { control, trigger } = form;

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) =>
          typeof value === 'boolean' ||
          i18n.t('Wybierz, dla kogo jest ten zakup'),
      }}
      render={({ field, fieldState: { error } }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              layout="horizontal"
              value={
                typeof field.value === 'boolean'
                  ? field.value
                    ? 'company'
                    : 'individual'
                  : undefined
              }
              onChange={(v) => {
                const isCompany = v === 'company';
                field.onChange(isCompany);
                if (!isCompany) clearCompanyInvoice(form);
                trigger(name);
              }}
            >
              <RadioItem
                className="bg-white"
                value="company"
                label={i18n.t('Dla firmy')}
              />
              <RadioItem
                className="bg-white"
                value="individual"
                label={i18n.t('Dla osoby prywatnej')}
              />
            </RadioGroup>
          </FormControl>
          {error && (
            <ErrorMessage errorMessage={error.message} className="!mt-1" />
          )}
        </FormItem>
      )}
    />
  );
};

export default RadioGroupBuyerType;
